import axios from "axios";
import LanguageService from "@/services/LanguageService";
import Constants from "@/services/Constants";

export default {
	async getCategories() {
		let res = await axios.get(`${Constants.backend}/categories/${LanguageService.langId}`);
		return res.data;
	},

	async getProductInfo(id) {
		let res = await axios.get(`${Constants.backend}/products/${id}`);
		return res.data;
	}
}